import React from 'react';

import ExperimentProvider from '../contexts/experiment-context';
import ExperimentDetail from './index';
import { ExperimentFormMode } from '@/features/experiment/constants';

const WrappedExperimentFormV2 = () => {
  return (
    <ExperimentProvider>
      <ExperimentDetail />
    </ExperimentProvider>
  );
};

export type ExperimentFormModeType =
  (typeof ExperimentFormMode)[keyof typeof ExperimentFormMode];

export default WrappedExperimentFormV2;
